import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '80%',
    },
    pos: {
        marginBottom: 12,
    },
});

export default function LivroProfile({ livro }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <Grid container justifyContent='space-evenly' spacing={3}>
                    <Grid size={5}>
                        <Typography variant="body1" color="textSecondary" gutterBottom>
                            Livro
                        </Typography>
                        <Typography variant="body1" >
                            {livro.descricao}
                        </Typography>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
}